import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var DeleteRow = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7 21.148c-.5 0-1 .501-1 1.002v1.404H3v-7.217h18.7a1.003 1.003 0 0 0 0-2.004H3V8.018c0-.5.4-.902.9-.902h17.3c.6 0 1-.4 1-1.002 0-.601-.4-1.002-1-1.002H3.9C2.3 5.112 1 6.415 1 8.018v33.075C1 42.697 2.3 44 3.9 44h32.9c1.6 0 3-1.303 3-2.907V22.15c-.1-.5-.5-1.002-1.1-1.002Zm-1 20.046c0 .5-.4.902-.9.902H3.9c-.5 0-.9-.401-.9-.902v-6.315h34.8v6.315h-.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9 0a8.61 8.61 0 0 0-8.6 8.62c0 4.71 3.8 8.62 8.6 8.62 4.7 0 8.6-3.81 8.6-8.62C43.4 3.809 39.6 0 34.9 0Zm0 15.235c-3.6 0-6.6-2.907-6.6-6.615 0-3.709 3-6.615 6.6-6.615 3.6 0 6.5 2.906 6.5 6.615 0 3.708-2.9 6.615-6.5 6.615Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2 8.62c0 .5-.4 1.002-1 1.002h-6.6c-.5 0-1-.501-1-1.002 0-.602.5-1.003 1-1.003h6.6c.5 0 1 .401 1 1.003Z"
  }));
});
DeleteRow.displayName = 'DeleteRow';
DeleteRow.defaultProps = {
  'aria-label': 'DeleteRow'
};
export default DeleteRow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/DeleteRow.js
// module id = 3541
// module chunks = 11